import React, { useEffect } from 'react';
import PageBanner from './PageBanner';
import About from '../About';
import FeaturedProducts from '../FeaturedProducts';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'About Us - Chikin Lady | Cluckin\' Awesome Lifestyle';
  }, []);

  return (
    <>
      <PageBanner
        badge="🐔 Welcome to the Flock"
        title="About the Chikin Lady"
        subtitle="The most cluckin' awesome brand around! We bring attitude, personality, and vibrant poultry passion to apparel, art, and digital fun."
        primaryText="🛒 Shop Merchandise"
        primaryLink="/chikin-lady-shopping"
        secondaryText="🏠 Main Store"
        secondaryLink="/"
      />
      <About />
      <FeaturedProducts />
    </>
  );
};

export default AboutPage;
